import { render } from "./JobDetailsPanel.vue?vue&type=template&id=74b8f0d5&scoped=true"
import script from "./JobDetailsPanel.vue?vue&type=script&lang=js"
export * from "./JobDetailsPanel.vue?vue&type=script&lang=js"

import "./JobDetailsPanel.vue?vue&type=style&index=0&id=74b8f0d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b8f0d5"]])

export default __exports__